import Bloc from './Bloc.js';
import Types from './Types.js';
import Library from '../../utility/Library.js';

export default class Potion extends Bloc {

	constructor (src, ctx) {

		super("potion", src, ctx, true);
		this.f = (src, ins) => {

			let champion = src.master.run.champion;
			let itempool = Object.values(Library.potions)
	            .filter(item =>
	                item.rarity && (src.starter || item.rarity === 1) && (!item.rank || src.master.run.power >= item.rank) &&
	                (!item.champion || item.champion === champion.model.key || (Array.isArray(item.champion) && item.champion.includes(champion.model.key)))
	            );
	        for (let i = 0; i < ins[0]; i++) {
		        let potion = itempool[Math.floor(Math.random() * itempool.length)];
		        champion.newPotion(potion);
		    }

			src.master.notify("brewpotion");

			return [];
		};
		this.types = [Types.int];
	}
}
